import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import '../styles/UserActivationVerify.css';

import { ApiContext } from '../context/ApiContext';
const UserActivationVerify = () => {
    const location = useLocation();
    const apiUrl = useContext(ApiContext);
    // const email = location.state?.email || '';
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email') || '';
    const activationCodeFromQuery = queryParams.get('activationCode') || '';
    console.log('Email passed to UserActivationVerify:', email);
    const [activationCode, setActivationCode] = useState(activationCodeFromQuery || '');
    // const [password, setPassword] = useState('');

    const navigate = useNavigate();
    const handleUserActivationVerify = async () => {
        try {
            const response = await fetch(`${apiUrl}/api/v1/user-activation/verify`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ activationCode, email }),
            });

            if (response.ok) {
                const { accessToken, accessTokenExpiresAt, refreshToken, refreshTokenExpiresAt } = await response.json();
                localStorage.setItem('accessToken', accessToken);
                localStorage.setItem('accessTokenExpiresAt', accessTokenExpiresAt);
                localStorage.setItem('refreshToken', refreshToken);
                localStorage.setItem('refreshTokenExpiresAt', refreshTokenExpiresAt);
                alert('Congratulations! Your email was successfuly validated. Enjoy your time!');
                navigate('/posts');
                // navigate('/');
            } else {
                alert('UserActivationVerify Failed!');
            }
        } catch (error) {
            console.error('Error during user activation:', error);
            alert('An error occurred. Please try again.');
        }
    };

    return (
        <div className="UserActivationVerify">
            <h2>Activate User</h2>
            <form>
                <div>
                    <label>This is your first Login. </label>
                    <label>Email verification is required.</label>
                    <label>Please check your inbox.</label>
                    <input
                        type="text"
                        value={activationCode}
                        onChange={(e) => setActivationCode(e.target.value)}
                        placeholder="XXXXX-XXXXX"
                        required
                    />
                </div>
                <div className="form-buttons">
                    <button type="button" onClick={() => window.history.back()}>Back</button>
                    <button type="button" onClick={handleUserActivationVerify}>Next</button>
                </div>
            </form>
        </div>
    );
};

export default UserActivationVerify;
